import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { VerifyPhoneNumberModule } from '@shared/verify-phone-number/verify-phone-number.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { ResultComponent, StatusErrorComponent, StatusSuccessComponent, StatusWarningComponent } from './components';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';
import { MarineInsuranceSharedModule } from '@shared/marine-insurance-shared';

@NgModule({
  declarations: [ResultComponent, StatusWarningComponent, StatusSuccessComponent, StatusErrorComponent],
  imports: [CommonModule, MutualModule, InputPhoneModule, VerifyPhoneNumberModule, RouterModule, MarineInsuranceSharedModule],
  exports: [ResultComponent, StatusWarningComponent, StatusSuccessComponent, StatusErrorComponent],
})
export class ResultModule {}
